import { useEffect } from 'react';
import type { EntryPoint, RequestOrigin, SourceMfe } from '@servicetitan/financing-api-client';
import { setFinancingAttribution } from './financingAttribution';

export interface UseRequestAttributionRumParams {
    origin?: RequestOrigin;
    entryPoint?: EntryPoint;
    sourceMfe?: SourceMfe;
    provider?: string;
}

/** Writes financingAttribution onto the host `window.DD_RUM` instance. */
export function useRequestAttributionRum({
    origin,
    entryPoint,
    sourceMfe,
    provider,
}: UseRequestAttributionRumParams) {
    useEffect(() => {
        setFinancingAttribution({ origin, entryPoint, sourceMfe, provider });
    }, [origin, entryPoint, sourceMfe, provider]);
}

export {
    getFinancingAttribution,
    resetFinancingAttribution,
    setFinancingAttribution,
} from './financingAttribution';
export type { FinancingAttribution } from './financingAttribution';
